import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from 'wire-frame';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class AppointmentService {

  private apiUrl: string;

  constructor(private http: HttpClient, private common: CommonService, private apiService: ApiService) { 
    this.apiUrl = this.apiService.getBaseUrl();
  }

  private getAuthHeaders() {
      const token = localStorage.getItem('jwtToken');
      return {
        headers: new HttpHeaders({
          'Authorization' : `Bearer ${token}`
        })
      }
    }

  getAppointment(from?: string, to?: string) {

    const params: any = {};
    if (from) params.from = from;
    if (to) params.to = to;

    return this.http.get(
      // this.common.getBaseUrl() + 'Appointment.php?action=AppointmentsList' + (payload ? '&list=all' : '')
      this.apiUrl + '/appointment', { params, ...this.getAuthHeaders()}, 
    );
  }

  addAppointment(payload: any) {
    // return this.http.post('/api/destinations', destination);
    payload["action"] = "addAppointment";
    // return this.http.post(this.common.getBaseUrl() + 'Appointment.php', payload);
    return this.http.post(this.apiUrl + '/appointment', payload, this.getAuthHeaders());
  }

  updateAppointment(payload: any) {
    payload["action"] = "updateAppointment";
    // return this.http.put(this.common.getBaseUrl() + 'Appointment.php', payload);
    return this.http.put(this.apiUrl + '/appointment/' + payload.id, payload, this.getAuthHeaders());
  }

  deleteAppointment(payload: any) {
    payload["action"] = "deleteAppointment";
    return this.http.put(this.common.getBaseUrl() + 'Appointment.php', payload);
  }

  searchPatients(query: string) {
    return this.http.get(this.apiUrl + '/patient/search', { params: { q: query }, ...this.getAuthHeaders() });
  }

  getQueue(payload: any) {
    return this.http.post(this.apiUrl + '/queue', payload, this.getAuthHeaders());
  }

  getMedicineQueue(payload: any) {
    return this.http.post(this.apiUrl + '/queue/medicine', payload, this.getAuthHeaders());
  }

  getDoctorQueueSummary(params: { doctor_id?: string | number | null; date?: string }) {
    const query: any = {};
    if (params.doctor_id) query.doctor_id = String(params.doctor_id);
    if (params.date) query.date = params.date;
    return this.http.get(this.apiUrl + '/queue/doctor-summary', { params: query, ...this.getAuthHeaders() });
  }

  getAllMedicineQueue(payload: any) {
    return this.http.post(this.apiUrl + '/queue/medicine/all', payload, this.getAuthHeaders());
  }

  getAppointmentDetails(id: number) {
    return this.http.get(this.apiUrl + '/appointments/' + id + '/details', this.getAuthHeaders());
  }

  changeStatus(id: number, status: string) {
    return this.http.post(this.apiUrl + '/appointment/' + id + '/status', { status }, this.getAuthHeaders());
  }

  ccAvenuePayment(payload: any) {
    return this.http.post(this.apiUrl + '/generate-ccavenue-request', payload);
  }
}
